module.exports = __webpack_public_path__ + "img/john-lemon.6cfa7046.png";